export const DEFAULT_COVER_DEVELOPMENT =
  'https://qsenozfawbynwkmpxyjr.supabase.co/storage/v1/object/public/project-photos/dev.webp';

export const DEFAULT_COVER_RENOVATION =
  'https://qsenozfawbynwkmpxyjr.supabase.co/storage/v1/object/public/project-photos/reno.webp';

const DEFAULT_URLS = new Set([DEFAULT_COVER_DEVELOPMENT, DEFAULT_COVER_RENOVATION]);

/**
 * Return the default cover URL for a given project type.
 * Falls back to Renovation default if type is unknown.
 */
export function getDefaultCoverUrl(projectType: string | null | undefined): string {
  if (projectType === 'Development') return DEFAULT_COVER_DEVELOPMENT;
  if (projectType === 'Renovation') return DEFAULT_COVER_RENOVATION;
  return DEFAULT_COVER_RENOVATION;
}

/**
 * Return true if the given URL is one of the known default covers.
 */
export function isDefaultCoverUrl(url: string | null | undefined): boolean {
  if (!url) return true;
  return DEFAULT_URLS.has(url.trim()) || url.includes('readdy.ai/api/search-image');
}

/**
 * Resolve the actual cover image URL for a project.
 * Priority:
 *   1. Custom uploaded cover (cover_image) if present
 *   2. Default image based on project_type
 *   3. Renovation fallback if project_type is missing
 */
export function getProjectCoverImage(project: {
  cover_image?: string | null;
  project_type?: string | null;
}): string {
  if (project.cover_image?.trim()) return project.cover_image.trim();
  return getDefaultCoverUrl(project.project_type);
}